import {
  Component,
  HostBinding,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { SwUpdate } from '@angular/service-worker';

// @ts-ignore
import translationsEN from '../assets/i18n/en.json';
import { SessionService } from '../common-shared/session';
import { takeUntil } from 'rxjs/operators';
import { User } from '../../../backend-core-lib/app/common-shared/account/models';
import { Subject } from 'rxjs';
import { appRoutes } from './config';
import { NotificationsService } from '../common-shared/notifications';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import {
  AuthenticationResult,
  EventMessage,
  EventType,
} from '@azure/msal-browser';
import { filter } from 'lodash';
import { transformRawToFormly } from '../common-shared/forms';

declare var document: any;
@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit, OnDestroy {
  @HostBinding('class')
  readonly cssClass = 'app-root flex grow  dark:bg-surface-800';

  title = 'gov-app-platform';
  // user?: User;
  private destroy$ = new Subject<void>();
  constructor(
    private translateService: TranslateService,
    private sessionService: SessionService,
    private router: Router,
    private messageService: MessageService,
    private notificationsService: NotificationsService,
    private msalBroadcastService: MsalBroadcastService,
    private authService: MsalService,
    private activatedRoute: ActivatedRoute,
    private swUpdate: SwUpdate,
  ) {
    this.translateService.setTranslation('en', translationsEN);
    this.translateService.addLangs(['de', 'en']);
    this.translateService.setDefaultLang('en');
    this.translateService.use('en');
  }
  ngOnInit(): void {
    this.msalBroadcastService.msalSubject$.subscribe(
      async (result: EventMessage) => {
        console.log(result);
        if (result.eventType === EventType.LOGIN_SUCCESS) {
          const payload = result.payload as AuthenticationResult;
          if (!this.sessionService.isLoggingAlreadyUserMsal()) {
            console.log(payload);
            console.log(payload.account);
            this.authService.instance.setActiveAccount(payload.account);

            const errorMessage = await this.sessionService.loginUserMsal(
              this.authService?.instance?.getAllAccounts()?.[0]?.idToken,
              this.authService?.instance?.getAllAccounts()?.[0]?.idTokenClaims
                ?.exp,
            );
            console.log(errorMessage);
            console.log(window.location.href);
            if (
              !errorMessage &&
              (window.location.href || '').indexOf('panel') < 0
            ) {
              this.router.navigate([appRoutes['dashboard']]);
              return;
            }
          }
        } else if (result.eventType === EventType.ACQUIRE_TOKEN_FAILURE) {
          this.sessionService.setFailedRecoverMsal();
        } else if (result.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) {
          const payload = result.payload as AuthenticationResult;
          console.log(payload);
          console.log(payload.account);
          this.authService.instance.setActiveAccount(payload.account);
          console.log(this.authService.instance.getAllAccounts());
        } else if (result.eventType === EventType.INITIALIZE_END) {
          this.sessionService
            .tryRecoverSession()
            .then(async (resultRecovered: boolean) => {
              // Check if msal
              if (resultRecovered) {
                /*this.router.navigate([appRoutes['dashboard']]);
                this.initialized = true;*/
                return;
              }

              const errorMessage = await this.sessionService.loginUserMsal(
                this.authService?.instance?.getAllAccounts()?.[0]?.idToken,
                this.authService?.instance?.getAllAccounts()?.[0]?.idTokenClaims
                  ?.exp,
              );
              console.log(errorMessage);
              if (!errorMessage) {
                /*this.router.navigate([appRoutes['dashboard']]);
                this.initialized = true;*/
                return;
              }

              /*this.router.navigate([appRoutes['login']]);
              this.initialized = true;*/

              this.sessionService.setForceToLogin(true);
            });

          if (this.authService.instance.getAllAccounts()?.length) {
            this.authService
              .acquireTokenSilent({
                scopes: ['user.read', 'user.read.all'],
                account: this.authService.instance.getAllAccounts()[0],
              })
              .subscribe((silentPayload) => {
                console.log(silentPayload);
              });
            console.log(this.authService.instance.getAllAccounts());
          }

          // this.authService.instance.
        }
      },
    );

    this.notificationsService.notificationSubject$
      .pipe(takeUntil(this.destroy$))
      .subscribe((notification) => {
        this.messageService.add(notification);
      });
    this.notificationsService.notificationRemoveSubject$
      .pipe(takeUntil(this.destroy$))
      .subscribe((notificationId) => {
        this.messageService.clear(notificationId);
      });

    if (this.swUpdate) {
      console.log(`SwUpdate is available`);
      this.swUpdate.checkForUpdate().then((newUpdate) => {
        if (newUpdate) {
          console.log(`New Update found`);
          this.swUpdate.activateUpdate().then(() => {
            console.log('Updated!');
            window.location.reload();
          });
        }
      });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
